export const types = [
    {
        id: 1,
        name: "Bureau tabac",
        name_ar: "مكتب التبغ"
    },
    {
        id: 2,
        name: "Alimentation Générale",
        name_ar: "أغذية عامة"
    },
    {
        id: 3,
        name: "Supérette",
        name_ar: "محل بقالة"
    },
    {
        id: 4,
        name: "Pharmacie",
        name_ar: "صيدلة"
    },
    {
        id: 5,
        name: "Piéce de rechange",
        name_ar: "محل قطع غيار"
    },
    {
        id: 6,
        name: "Centre d'entretien et lavage",
        name_ar: "مركز صيانة وغسيل"
    },
    {
        id: 7,
        name: "Droguerie - Quincaillerie",
        name_ar: "محل معدات"
    },
    {
        id: 8,
        name: "Chauffeur VTC",
        name_ar: "سائق نقل خاص VTC"
    },
    {
        id: 9,
        name: "Boutique de Smartphones",
        name_ar: "محل الهواتف الذكية"
    }
];